import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { useAnalytics } from '@/hooks/useAnalytics';
import type { PlatformTypes } from '@/types/gql.generated';
import type { Destination } from '../types';

interface ExportModalState {
  openPlatform: PlatformTypes | null;
  isModalWorkflow: boolean;
  lastDestination: Destination | null;
  eventId: string | null;

  setOpenPlatform: (
    platform: PlatformTypes | null,
    eventId: string | null
  ) => void;
  setIsModalWorkflow: (isWorkflow: boolean) => void;
  closeModal: (destination?: Destination | null) => void;

  isOpen: boolean;
}

const useInternalExportModalStore = createWithEqualityFn<ExportModalState>()(
  (set) => ({
    openPlatform: null,
    isModalWorkflow: false,
    isOpen: false,
    lastDestination: null,
    eventId: null,

    setOpenPlatform: (platform, eventId) =>
      set({ openPlatform: platform, isOpen: !!platform, eventId }),
    setIsModalWorkflow: (isWorkflow) => set({ isModalWorkflow: isWorkflow }),
    closeModal: (destination = null) =>
      set({
        openPlatform: null,
        isOpen: false,
        lastDestination: destination,
        eventId: null,
      }),
  }),
  shallow
);

export const useExportModalStore = () => {
  const { trackEvent } = useAnalytics();
  const { setOpenPlatform, ...rest } = useInternalExportModalStore();

  const handleOpen: ExportModalState['setOpenPlatform'] = (
    platform,
    eventId
  ) => {
    if (platform) {
      trackEvent('magic-export-modal:open', {
        isAddAll: !eventId,
        platform,
      });
    }
    setOpenPlatform(platform, eventId);
  };

  return {
    setOpenPlatform: handleOpen,
    ...rest,
  };
};
